import { all } from "@redux-saga/core/effects";
import { combineReducers } from "redux";
// import { login, loginWorker } from "./login";
import {
  selectOptionUaIsin,
  select_option_ua_isin_reducer,
} from "redux/option/select_option_ua_isin";
import {
  Select_Pledge_customer_reducer,
  selectPledgeCustomert,
} from "redux/pledge/select_pledge_customer";
import {
  selectStockSummaries,
  select_Stock_Summaries_Reducer,
} from "redux/stock/select_summaries";
import {
  Tadbir_select_order_reducer,
  selectTadbirSelectOrder,
} from "redux/tadbir/select_order";
import {
  Tadbir_select_orderbook_reducer,
  selectTadbirSelectOrderbook,
} from "redux/tadbir/select_orderbook";
import {
  coveredCallReducer,
  covered_call_reducer,
} from "./OptionStrategys/coveredCall";
import {
  selectPortfoliodetailLast,
  select_last_portfolio_detail_reducer,
} from "./charts-tables-data/select-last-protfolio-detail";
import {
  selectOptionPortfolio,
  select_option_portfolio_reducer,
} from "./charts-tables-data/select-option-protfolio";
import {
  selectPortfoliodetail,
  select_portfolio_detail_reducer,
} from "./charts-tables-data/select_Portfolio_details";
import {
  selectSuperiorIndustries,
  select_superior_industries_reducer,
} from "./charts-tables-data/select_Suprior_Industries";
import {
  selectPortfolioindustriesLast,
  select_last_portfolio_industries_reducer,
} from "./charts-tables-data/select_last_portfolio_industries";
import {
  selectLivePortfolio,
  select_live_portfolio_reducer,
} from "./charts-tables-data/select_live_portfolio";
import {
  selectPortfolio,
  select_portfolio_reducer,
} from "./charts-tables-data/select_portfolio";
import {
  selectPortfolioHistory,
  select_portfolio_history_reducer,
} from "./charts-tables-data/select_portfolio_history";
import {
  selectPortfolioKey,
  select_portfolio_key_reducer,
} from "./charts-tables-data/select_protfolio_key";
import {
  portfolioRiskSystematic,
  reducer_portfolio_portfolioRisk_systematic,
} from "./charts-tables-data/systematic_unsystematic_risk";
import {
  clubmember_Select,
  selectClubmember,
} from "./clubMember/clubmember_select";
import {
  selectTableDetails,
  select_details_table_reducer,
} from "./credit/selectDetails";
import {
  selectActiveTableCredit,
  select_credit_active_table_reducer,
} from "./credit/select_active_credit_plans";
import {
  selectCreditRelatedStatistics,
  select_credit_related_statistics_reducer,
} from "./credit/select_credit_related_statistics";
import {
  selectCreditRequests,
  select_credit_requests_reducer,
} from "./credit/select_credit_requests";
import {
  selectMemberCreditPlan,
  select_member_credit_plan_reducer,
} from "./credit/select_member_credit_plans";
import {
  selectSettlementStatistics,
  select_settlement_statistics_reducer,
} from "./credit/select_settlement_statistics";
import { insertTicket, insert_ticket_reducer } from "./insertTicket";
import { reducerLightstreamer } from "./lightstreamer";
import { loading } from "./loading";
import { selectLottery, select_lottery_reducer } from "./lottory/lottorySelect";
import {
  selectTableLottery,
  select_lottery_table_reducer,
} from "./lottory/lottorySelectTable";
import {
  selectMarkowitsCalculater,
  selectMarkowitsCalculaterReducer,
} from "./markowitz/calculate_markowitz_portfolio";
import {
  selectMarkowitsSymbol,
  selectMarkowitsSymbolReducer,
} from "./markowitz/select_markowitz_valid_symbols";
import {
  selectRecommendedProtfolio,
  selectRecommendedProtfolioReducer,
} from "./markowitz/select_recommended_portfolio";
import { reducer_notificationAlert } from "./notificationAlert";
import {
  Options_market_watch_select_reducer,
  SelectOptionsMarketWatch,
} from "./option/market_watch";
import {
  number_of_options_of_portfolio_instrumentsSelect,
  number_of_options_of_portfolio_instruments_select_reducer,
} from "./option/number_of_options_of_portfolio_instruments";
import {
  SelectOptionsMarketMap,
  select_options_market_map_reducer,
} from "./option/options_market_map";
import {
  AuthorityListSelect,
  AuthorityList_select_reducer,
} from "./option/options_of_instruments";
import {
  AuthoritySelect,
  Authority_select_reducer,
} from "./option/options_of_portfolio_instruments";
import {
  Options_report_select_reducer,
  SelectOptionsReport,
} from "./option/report";
import {
  Options_report_Excel_select_reducer,
  SelectOptionsExcelReport,
} from "./option/report/excel";
// import {
// 	activateT0Payment,
// 	activateT0PaymentReducer,
// } from "./payments/activate_t0_payment";
import {
  selectPaymentRequestsHistory,
  selectPaymentRequestsHistoryReducer,
} from "./payments/select_payment_requests_history";
import {
  selectPaymentRequestsLimits,
  selectPaymentRequestsLimitsReducer,
} from "./payments/select_payment_requests_limits";
import {
  selectPaymentRequestsRayanHistory,
  selectPaymentRequestsRayanHistoryReducer,
} from "./payments/select_payment_requests_rayan_history";
import {
  selectT0Limits,
  selectT0LimitsReducer,
} from "./payments/select_t0_limits";
import { profile, reducerProfile } from "./profile/clubmember_select_info";
import {
  reducer_get_kyc_profile,
  watcher_get_kyc_profile,
} from "./profile/get_kyc_profile";
import {
  reducerSelecStatusCkeckQuestint,
  selectStatusCkeckQuestint,
} from "./questionNaire/select_check_questionnaires_completion_status";
import { mySaga, reducer } from "./redux_test";
import {
  selectInstrument,
  select_Instrument_Reducer,
} from "./stock/selectInstrument";
import { EMPTYALLREDUCERS } from "./type";

import {
  cancelCreditRequest,
  cancel_credit_request_reducer,
} from "./credit/cancel_credit_request";

import {
  selectChangeBrokers,
  select_change_brokers_reducer,
} from "./changebroker";

import {
  selectCodalParticipation,
  select_codal_participation_reducer,
} from "./cachInterest";
import {
  selectChildren,
  select_children_reducer,
} from "./childrens/select_children";
import {
  selectChildrenPortfo,
  select_children_portfo_reducer,
} from "./childrens/select_children_portfo";
import {
  selectChildrenPortfoStats,
  select_children_portfo_stats_reducer,
} from "./childrens/select_children_portfo_stats";
import {
  selectDebtTransfers,
  select_debt_transfers_reducer,
} from "./childrens/select_debt_transfers";
import { selectSummaries, select_summaries_reducer } from "./select_summaries";

// import {
// 	confirmDebtTransferRequest,
// 	confirm_debt_transfer_request_reducer,
// } from "./childrens/confirm_debt_transfer_request";
import { getCaptcha, get_captcha_reducer } from "./get_captcha";
import {
  selectActiveIpos,
  selectActiveIposReducer,
} from "./ipo/select_active_ipos";
import {
  selectRegisteredIpos,
  selectRegisteredIposReducer,
} from "./ipo/select_registered_ipos";

import {
  Select_Pledge_spread_reducer,
  selectPledgeSpread,
} from "./strategy/select_pledge_spread";
import {
  selectInstrumentBasket,
  select_instrument_Basket_Reducer,
} from "./select_instrument";
import {
  selectBasketcustomer,
  select_basketcustomer_Reducer,
} from "./basketManagement/select_basketcustomer";
import {
  selectBasketcustomerGroup,
  select_basketcustomer_group,
} from "./basketManagement/select_basketcustomer_group";
import {
  selectBasketcustomerGroupDetail,
  select_basketcustomer_group_detail_Reducer,
} from "./basketManagement/select_basketcustomer_group_detail";

import {
  selectBasketcustomerOrderDetail,
  select_basketcustomer_order_detail_Reducer,
} from "./basketManagement/select_basketcustomer_order_detail";
import {
  selectStaticThresholds,
  select_static_thresholds_Reducer,
} from "./basketManagement/select_static_thresholds";

import {
  selectFinancialStatusBasket,
  select_financial_status_Reducer,
} from "./select_financial_status/indx";
import {
  selectStrategies,
  select_strategies_reducer,
} from "./select_strategies";
import {
  selectMemberMarketMaker,
  select_member_market_maker_Reducer,
} from "./marketMaker/select_member_market_maker";
import {
  selectConfigMarketMaker,
  select_config_market_maker_Reducer,
} from "./marketMaker/select_config_market_maker";
import {
  selectOrderMarketMaker,
  select_order_market_maker_Reducer,
} from "./marketMaker/select_order_market_maker";
import {
  selectFixInstrument,
  select_fix_instrument_Reducer,
} from "./marketMaker/select_fix_instrument";
import {
  selectMarketMakerWatchlist,
  select_market_maker_watchlist_Reducer,
} from "./marketMaker/select_market_maker_watchlist";
import {
  selectSymbolMarketMakerWatchlist,
  select_symbol_market_maker_watchlist_Reducer,
} from "./marketMaker/select_symbol_market_maker_watchlist";
import {
  selectMarketMakerAlgorithmicOption,
  select_market_maker_algorithmic_option_Reducer,
} from "./marketMakingAlgorithmic/select_market_maker_algorithmic_option";
import {
  selectBasketcustomerConfig,
  select_basketcustomer_config_Reducer,
} from "./basketManagement/select_basketcustomer_config";
import {
  selectBasketcustomerMember,
  select_basketcustomer_member_Reducer,
} from "./basketManagement/select_basketcustomer_member";
import {
  selectContracts,
  select_contracts_reducer,
} from "./direct_debit/select_contracts/index";
import {
  selectFinancialSejamProfile,
  selectFinancialSejamProfileReducer,
} from "./payments/select_financial_sejam_profile";
import {
  selectPodPayments,
  selectPodPaymentsReducer,
} from "./payments/select_pod_payments";
import {
  certificateAndGold,
  certificateAndGoldReducer,
} from "./gold/certificate_and_gold";
import { goldIndexes, goldIndexesReducer } from "./gold/gold_indexes";
import { goldMarketMap, goldMarketMapReducer } from "./gold/gold_market_map";
import { goldReturn, goldReturnReducer } from "./gold/gold_return";
import { goldFunds, goldFundsReducer } from "./gold/gold_funds";
import {
  selectSavingTransactions,
  select_saving_transactions_reducer,
} from "./direct_debit/select_saving_transactions";
import {
  selectWithdrawalBalance,
  selectWithdrawalBalanceReducer,
} from "./payments/select_withdrawal_balance";

import {
  userSelectCustomerSubset,
  user_select_customer_subset_Reducer,
} from "./marketer/user_select_customer_subset";

import {
  userSelectMarketerBankInfo,
  user_select_marketer_bank_info_Reducer,
} from "./marketer/user_select_marketer_bank_info";
import {
  userSelectMarketerIncomeChart,
  user_select_marketer_income_chart_Reducer,
} from "./marketer/user_select_marketer_income_chart";
import {
  userSelectNarketerSubsetNumberChart,
  user_select_marketer_subset_number_chart_Reducer,
} from "./marketer/user_select_marketer_subset_number_chart";
import {
  userSelectCustomerOpenOptionsChart,
  user_select_customer_open_options_chart_Reducer,
} from "./marketer/user_select_customer_open_options_chart";
import {
  userSelectCustomerPortfolioValueChart,
  user_select_customer_portfolio_value_chart_Reducer,
} from "./marketer/user_select_customer_portfolio_value_chart";
import {
  userSelectCustomerFeeChart,
  user_select_customer_fee_chart_Reducer,
} from "./marketer/user_select_customer_fee_chart";
import {
  userSelectUserSelectMarketerSubsetCostChart,
  user_select_marketer_subset_cost_chart_Reducer,
} from "./marketer/user_select_marketer_subset_cost_chart";
import {
  checkMarketerExistence,
  check_marketer_existence_Reducer,
} from "./marketer/check_marketer_existence";
import {
  userSelectCustomerFinancialChart,
  user_select_customer_financial_chart_Reducer,
} from "./marketer/user_select_customer_financial_chart";
import {
  userUserSelectMarketerCostChart,
  user_select_marketer_cost_chart_Reducer,
} from "./marketer/user_select_marketer_cost_chart";

import {
  onlineAssetsPrice,
  online_assets_priceReducer,
} from "./gold/online_assets_price";
import {
  userSelectMarketerCustomersName,
  user_select_marketer_customers_name_Reducer,
} from "./marketer/user_select_marketer_customers_name";
import {
  userSelectMarketerChangeBroker,
  user_select_marketer_change_broker_Reducer,
} from "./marketer/user_select_marketer_change_broker";
import {
  user_select_marketer_financial_bill_Reducer,
  userSelectMarketerFinancialBill,
} from "./marketer/user_select_marketer_financial_bill";
import {
  userSelectMarketerFinancialCostsBill,
  user_select_marketer_financial_costs_bill_Reducer,
} from "./marketer/user_select_marketer_financial_costs_bill";
import {
  userSelectMarketerFinancialCost,
  user_select_marketer_financial_cost_Reducer,
} from "./marketer/user_select_marketer_financial_cost";
import {
  userSelectMarketerFinancialIncome,
  user_select_marketer_financial_income_Reducer,
} from "./marketer/user_select_marketer_financial_income";
import {
  userSelectMarketerIncomeRatioChart,
  user_select_marketer_income_ratio_chart_Reducer,
} from "./marketer/user_select_marketer_income_ratio_chart";
import {
  userSelectMarketerCostRatioChart,
  user_select_marketer_cost_ratio_chart_Reducer,
} from "./marketer/user_select_marketer_cost_ratio_chart";
import {
  userSelectMarketerCreditSubsetNumberChart,
  user_select_marketer_credit_subset_number_chart_Reducer,
} from "./marketer/user_select_marketer_credit_subset_number_chart";
import {
  userSelectMarketerMarketersName,
  user_select_marketer_marketers_name_Reducer,
} from "./marketer/user_select_marketer_marketers_name";
import {
  userSelectMarketerMarketersSubsetCumberChart,
  user_select_marketer_marketers_subset_number_chart_Reducer,
} from "./marketer/user_select_marketer_marketers_subset_number_chart";
import {
  userSelectMarketerMarketersSubsetCostChart,
  user_select_marketer_marketers_subset_cost_chart_Reducer,
} from "./marketer/user_select_marketer_marketers_subset_cost_chart";
import {
  userSelectMarketerMarketersCostChart,
  user_select_marketer_marketers_cost_chart_Reducer,
} from "./marketer/user_select_marketer_marketers_cost_chart";
import {
  userSelectMarketerMarketersIncomeChart,
  user_select_marketer_marketers_income_chart_Reducer,
} from "./marketer/user_select_marketer_marketers_income_chart";
import {
  userSelectMarketerSubset,
  user_select_marketer_subset_Reducer,
} from "./marketer/user_select_marketer_marketers_subset/index";
import {
  userSelectMarketerCustomerIncomeTable,
  user_select_marketer_customer_income_table_Reducer,
} from "./marketer/user_select_marketer_customer_income_table/index";
import {
  userSelectMarketerBalanceTable,
  user_select_marketer_balance_table_Reducer,
} from "./marketer/user_select_marketer_balance_table/index";
import {
  userSelectMarketerCustomerFinancialTable,
  user_select_marketer_customer_financial_table_Reducer,
} from "./marketer/user_select_marketer_customer_financial_table/index";

import {
  userSelectMarketerFinancialFull,
  user_select_marketer_financial_full_Reducer,
} from "redux/marketer/user_select_marketer_financial_full/index";

import {
  selectOfflineOrders,
  selectOfflineOrdersReducer,
} from "redux/offlineorder/select_offline_orders";
import {
  selectOfflineOrdersWithFilters,
  selectOfflineOrdersWithFiltersReducer,
} from "redux/offlineorder/select_offline_orders_with_filters";
import {
  select_member_max_gold_credit_reducer,
  selectMemberMaxGoldCredit,
} from "./goldCredit/select_member_max_gold_credit";
import {
  select_member_next_days_remain_daily_fix_credit_reducer,
  selectMemberNextDaysRemainDailyFixCredit,
} from "./dailyCredit/select_member_next_days_remain";
import {
  select_marketer_contract,
  selectMarketerContract,
} from "./marketer/select_marketer_contract";
import {
  select_marketer_contract_pdf,
  selectMarketerContractPdf,
} from "./marketer/select_marketer_contract_pdf";
import {
  select_courses_reducer,
  selectCourses,
} from "./courses/select_courses";
import {
  selectIpoFinancialInfo,
  select_ipo_financial_info,
} from "./ipo/select_ipo_financial_info";
import {
  select_pec_payment_requests_Reducer,
  selectPecPaymentRequests,
} from "./payments/select_pec_payment_requests";
import {
  selectAtiPayments,
  selectAtiPaymentsReducer,
} from "./payments/select_ati_payments";
import {
  selectEnteghalTalabRequest,
  select_enteghal_talab_request_reducer,
} from "./payments/select_enteghal_talab_request";
import {
  select_best_limits_Reducer,
  selectBestLimits,
} from "./offlineorder/select_best_limits";
import { select_offline_orders_history_Reducer, selectOfflineOrdersHistory } from "./offlineorder/select_offline_orders_history";

export const appReducer = combineReducers({
  reducer_notificationAlert,
  reducer,
  // login,
  select_contracts_reducer,
  user_select_marketer_marketers_name_Reducer,
  selectOfflineOrdersWithFiltersReducer,
  selectOfflineOrdersReducer,
  user_select_marketer_marketers_subset_cost_chart_Reducer,
  user_select_marketer_marketers_cost_chart_Reducer,
  user_select_marketer_customer_financial_table_Reducer,
  user_select_marketer_financial_income_Reducer,
  user_select_marketer_balance_table_Reducer,
  user_select_marketer_income_ratio_chart_Reducer,
  user_select_marketer_subset_Reducer,
  user_select_marketer_financial_full_Reducer,
  user_select_marketer_financial_costs_bill_Reducer,
  user_select_marketer_credit_subset_number_chart_Reducer,
  user_select_marketer_customer_income_table_Reducer,
  user_select_customer_open_options_chart_Reducer,
  user_select_marketer_marketers_subset_number_chart_Reducer,
  user_select_marketer_cost_ratio_chart_Reducer,
  user_select_marketer_change_broker_Reducer,
  user_select_marketer_financial_cost_Reducer,
  user_select_marketer_financial_bill_Reducer,
  user_select_marketer_subset_cost_chart_Reducer,
  user_select_customer_portfolio_value_chart_Reducer,
  online_assets_priceReducer,
  select_saving_transactions_reducer,
  user_select_marketer_customers_name_Reducer,
  user_select_customer_fee_chart_Reducer,
  user_select_marketer_marketers_income_chart_Reducer,
  user_select_marketer_cost_chart_Reducer,
  user_select_marketer_income_chart_Reducer,
  user_select_customer_financial_chart_Reducer,
  check_marketer_existence_Reducer,
  user_select_marketer_subset_number_chart_Reducer,
  certificateAndGoldReducer,
  user_select_customer_subset_Reducer,
  goldFundsReducer,
  user_select_marketer_bank_info_Reducer,
  goldIndexesReducer,
  goldMarketMapReducer,
  goldReturnReducer,
  selectWithdrawalBalanceReducer,
  cancel_credit_request_reducer,
  selectPodPaymentsReducer,
  selectAtiPaymentsReducer,
  select_children_portfo_reducer,
  select_market_maker_algorithmic_option_Reducer,
  select_basketcustomer_member_Reducer,
  select_basketcustomer_Reducer,
  select_debt_transfers_reducer,
  select_codal_participation_reducer,
  select_market_maker_watchlist_Reducer,
  select_basketcustomer_config_Reducer,
  select_children_portfo_stats_reducer,
  selectFinancialSejamProfileReducer,
  select_strategies_reducer,
  select_basketcustomer_group_detail_Reducer,
  // confirm_debt_transfer_request_reducer,
  select_summaries_reducer,
  select_portfolio_reducer,
  select_details_table_reducer,
  select_symbol_market_maker_watchlist_Reducer,
  select_member_market_maker_Reducer,
  select_fix_instrument_Reducer,
  select_children_reducer,
  select_order_market_maker_Reducer,
  select_config_market_maker_Reducer,
  select_portfolio_history_reducer,
  selectActiveIposReducer,
  select_instrument_Basket_Reducer,
  select_financial_status_Reducer,
  select_change_brokers_reducer,
  select_last_portfolio_detail_reducer,
  select_option_portfolio_reducer,
  select_portfolio_key_reducer,
  select_portfolio_detail_reducer,
  loading,
  Select_Pledge_spread_reducer,
  selectRegisteredIposReducer,
  select_superior_industries_reducer,
  get_captcha_reducer,
  clubmember_Select,
  select_basketcustomer_group,
  reducer_portfolio_portfolioRisk_systematic,
  reducer_get_kyc_profile,
  select_lottery_reducer,
  reducerSelecStatusCkeckQuestint,
  select_lottery_table_reducer,
  reducerProfile,
  select_basketcustomer_order_detail_Reducer,
  selectPaymentRequestsLimitsReducer,
  selectPaymentRequestsHistoryReducer,
  selectPaymentRequestsRayanHistoryReducer,
  Authority_select_reducer,
  AuthorityList_select_reducer,
  reducerLightstreamer,
  number_of_options_of_portfolio_instruments_select_reducer,
  select_Instrument_Reducer,
  selectMarkowitsSymbolReducer,
  selectMarkowitsCalculaterReducer,
  selectRecommendedProtfolioReducer,
  Options_market_watch_select_reducer,
  select_options_market_map_reducer,
  covered_call_reducer,
  Options_report_select_reducer,
  Options_report_Excel_select_reducer,
  select_last_portfolio_industries_reducer,
  select_Stock_Summaries_Reducer,
  Tadbir_select_order_reducer,
  Tadbir_select_orderbook_reducer,
  Select_Pledge_customer_reducer,
  select_static_thresholds_Reducer,
  select_option_ua_isin_reducer,
  select_live_portfolio_reducer,
  select_credit_active_table_reducer,
  select_member_credit_plan_reducer,
  select_credit_related_statistics_reducer,
  select_credit_requests_reducer,
  insert_ticket_reducer,
  select_settlement_statistics_reducer,
  selectT0LimitsReducer,
  select_member_max_gold_credit_reducer,
  select_member_next_days_remain_daily_fix_credit_reducer,
  select_marketer_contract,
  select_marketer_contract_pdf,
  select_courses_reducer,
  select_ipo_financial_info,
  select_pec_payment_requests_Reducer,
  select_enteghal_talab_request_reducer,
  select_best_limits_Reducer,
  select_offline_orders_history_Reducer,

  // activateT0PaymentReducer,
});

export function* rootSaga() {
  yield all([
    // loginWorker(),
    mySaga(),
    userSelectCustomerPortfolioValueChart(),
    selectT0Limits(),
    selectTableDetails(),
    userSelectMarketerMarketersCostChart(),
    // activateT0Payment(),
    // confirmDebtTransferRequest(),
    userSelectMarketerMarketersIncomeChart(),
    selectChangeBrokers(),
    selectDebtTransfers(),
    selectTableDetails(),
    selectChildrenPortfo(),
    selectChildrenPortfoStats(),
    userSelectMarketerSubset(),
    selectChildren(),
    selectSummaries(),
    userSelectMarketerMarketersSubsetCumberChart(),
    selectPortfolio(),
    userSelectMarketerFinancialBill(),
    userSelectMarketerFinancialCostsBill(),
    selectPortfolioHistory(),
    userSelectMarketerIncomeRatioChart(),
    selectPortfoliodetailLast(),
    selectOptionPortfolio(),
    selectPortfolioKey(),
    selectPortfoliodetail(),
    userSelectMarketerFinancialCost(),
    selectSuperiorIndustries(),
    getCaptcha(),
    selectClubmember(),
    portfolioRiskSystematic(),
    watcher_get_kyc_profile(),
    userSelectCustomerFinancialChart(),
    selectLottery(),
    userSelectMarketerCustomerIncomeTable(),
    userSelectMarketerChangeBroker(),
    selectStatusCkeckQuestint(),
    selectBasketcustomerGroup(),
    selectActiveIpos(),
    selectTableLottery(),
    selectPledgeSpread(),
    userUserSelectMarketerCostChart(),
    selectFinancialSejamProfile(),
    checkMarketerExistence(),
    profile(),
    userSelectCustomerFeeChart(),
    selectPaymentRequestsLimits(),
    selectPaymentRequestsHistory(),
    selectPaymentRequestsRayanHistory(),
    selectSavingTransactions(),
    AuthoritySelect(),
    AuthorityListSelect(),
    number_of_options_of_portfolio_instrumentsSelect(),
    selectInstrument(),
    selectMarkowitsSymbol(),
    selectMarkowitsCalculater(),
    selectRecommendedProtfolio(),
    SelectOptionsMarketWatch(),
    SelectOptionsMarketMap(),
    userSelectMarketerBalanceTable(),
    userSelectMarketerSubset(),
    coveredCallReducer(),
    SelectOptionsReport(),
    SelectOptionsExcelReport(),
    selectPortfolioindustriesLast(),
    selectBasketcustomer(),
    selectStockSummaries(),
    selectMemberCreditPlan(),
    selectTadbirSelectOrder(),
    selectTadbirSelectOrderbook(),
    selectOrderMarketMaker(),
    selectStockSummaries(),
    userSelectMarketerCustomerFinancialTable(),
    selectPledgeCustomert(),
    selectOptionUaIsin(),
    selectLivePortfolio(),
    userSelectUserSelectMarketerSubsetCostChart(),
    selectWithdrawalBalance(),
    selectActiveTableCredit(),
    selectPodPayments(),
    selectAtiPayments(),
    userSelectMarketerFinancialFull(),
    userSelectMarketerMarketersSubsetCostChart(),
    userSelectMarketerMarketersName(),
    userSelectMarketerCostRatioChart(),
    selectSymbolMarketMakerWatchlist(),
    selectCreditRelatedStatistics(),
    selectCreditRequests(),
    insertTicket(),
    onlineAssetsPrice(),
    userSelectMarketerFinancialIncome(),
    selectSettlementStatistics(),
    cancelCreditRequest(),
    userSelectNarketerSubsetNumberChart(),
    userSelectMarketerIncomeChart(),
    selectOfflineOrders(),
    userSelectMarketerCustomersName(),
    selectCodalParticipation(),
    selectBasketcustomerMember(),
    selectBasketcustomerGroupDetail(),
    selectRegisteredIpos(),
    userSelectMarketerCreditSubsetNumberChart(),
    userSelectMarketerBankInfo(),
    selectInstrumentBasket(),
    selectMemberMarketMaker(),
    selectMarketMakerWatchlist(),
    selectFinancialStatusBasket(),
    selectStrategies(),
    selectMarketMakerAlgorithmicOption(),
    goldFunds(),
    selectBasketcustomerConfig(),
    selectBasketcustomerOrderDetail(),
    certificateAndGold(),
    goldIndexes(),
    goldMarketMap(),
    goldReturn(),
    userSelectCustomerOpenOptionsChart(),
    selectContracts(),
    selectConfigMarketMaker(),
    selectOfflineOrdersWithFilters(),
    selectFixInstrument(),
    selectStaticThresholds(),
    userSelectCustomerSubset(),
    selectMemberMaxGoldCredit(),
    selectMemberNextDaysRemainDailyFixCredit(),
    selectMarketerContract(),
    selectMarketerContractPdf(),
    selectCourses(),
    selectIpoFinancialInfo(),
    selectPecPaymentRequests(),
    selectEnteghalTalabRequest(),
    selectBestLimits(),
    selectOfflineOrdersHistory(),
  ]);
}

export const rootReducer = (state, action) => {
  if (action.type === EMPTYALLREDUCERS) {
    state = undefined;
    localStorage.clear();
  }
  return appReducer(state, action);
};
